export default __webpack_public_path__ + "static/media/ZawadiHighRes.9f336153.gif";